import axios from 'axios'
import AuthToken from '@/auth/auth-token'

class Party {
  constructor () {
    const base = axios.create({
      baseURL: process.env.VUE_APP_CUSTOMER_API,
      withCredentials: false,
      headers: {
        'Content-type': 'application/json'
      }
    })
    this.party = base
  }

  async getUserProfile ({ 
    email, 
    include_stores = false, 
    limit_stores = false, 
    owners_from_children = false, 
    extended_access = false, 
    limit_subvendors = false 
  } = {}) {
    await AuthToken.setAuth(this.party, {
      audience: process.env.VUE_APP_CUSTOMER_AUDIENCE
    })
    return this.party({
      url: '/user_profile',
      method: 'GET',
      params: { 
        email, include_stores, limit_stores, owners_from_children, extended_access, limit_subvendors 
      }
    })
  }

  async getCustomerId (email) {
    await AuthToken.setAuth(this.party, {
      audience: process.env.VUE_APP_CUSTOMER_AUDIENCE
    })
    const party_email = email
    const party_type = 'USER'
    return this.party({
      url: '/party/customer_id',
      method: 'GET',
      params: { party_email, party_type }
    })
  }

  async get (party_id) {
    await AuthToken.setAuth(this.party, {
      audience: process.env.VUE_APP_CUSTOMER_AUDIENCE
    })
    return this.party({
      url: `/party/${party_id}`,
      method: 'GET'
    })
  }

  async getStoresByAdGroup (partyId) {
    await AuthToken.setAuth(this.party, {
      audience: process.env.VUE_APP_CUSTOMER_AUDIENCE
    })
    return this.party({
      url: `/all_stores_for_adgroup/${partyId}`,
      method: 'GET'
    })
  }

  async getAllStoresForTenant () {
    await AuthToken.setAuth(this.party, {
      audience: process.env.VUE_APP_CUSTOMER_AUDIENCE
    })
    return this.party({
      url: `/all_stores_for_tenant`,
      method: 'GET'
    })
  }

  async getAllVendorsParty () {
    await AuthToken.setAuth(this.party, {
      audience: process.env.VUE_APP_CUSTOMER_AUDIENCE
    })
    return this.party({
      url: '/party/search_parties',
      method: 'POST',
      data: { 
        party_email: 'arg_all_vendors@iprosystems.com',
        party_types: ['VENDOR'] 
      }
    }).then(res => {
      return res?.data?.length === 1 ? res.data[0] : null
    })
  }

  async getAllRetailersParty () {
    await AuthToken.setAuth(this.party, {
      audience: process.env.VUE_APP_CUSTOMER_AUDIENCE
    })
    return this.party({
      url: '/party/search_parties',
      method: 'POST',
      data: { 
        party_email: 'arg_all_retailers@iprosystems.com',
        party_types: ['STORE'] 
      }
    }).then(res => {
      return res?.data?.length === 1 ? res.data[0] : null
    })
  }

  async getUpstreamPartiesBatch (partyIds, partyTypeFilter = null, include_future = false) {
    await AuthToken.setAuth(this.party, {
      audience: process.env.VUE_APP_CUSTOMER_AUDIENCE
    })
    const data = {
      party_ids: Array.isArray(partyIds) ? partyIds : [partyIds]
    }
    const params = {
      include_future: include_future
    }
    if (partyTypeFilter) {
      data.party_type_filter = Array.isArray(partyTypeFilter) ? partyTypeFilter : [partyTypeFilter]
    }
    return this.party({
      url: '/party_relationship/upstream_batch',
      method: 'POST',
      params: params,
      data
    })
  }
}

export default new Party()